import { _objectKeys } from 'fast-json-patch/module/helpers';
import { QuestionnaireResponse, QuestionnaireResponseItem } from 'fhir/r4b';
import { evalEnableWhen } from 'utils/lib/helpers/paperwork/validation';
import { IntakeQuestionnaireItem } from 'utils/lib/types/data/paperwork/paperwork.types';

type DisplayStrategy = 'enabled' | 'hidden' | 'protected';
// this is called without all items in one place
export const getItemDisplayStrategy = (
  item: IntakeQuestionnaireItem,
  items: IntakeQuestionnaireItem[],
  values: { [itemLinkId: string]: QuestionnaireResponseItem },
  questionnaireResponse?: QuestionnaireResponse
): DisplayStrategy => {
  if (item.readOnly) {
    return item.disabledDisplay ?? 'hidden';
  }
  const enabled = evalEnableWhen(item, items, values, questionnaireResponse);
  if (!enabled) {
    return item.disabledDisplay ?? 'hidden';
  }
  // a calculated item is a formula field: it is shown (read only) unless it asks to be hidden
  if (item.calculatedExpression) {
    return item.disabledDisplay ?? 'protected';
  }
  return 'enabled';
};
